export const getValueFromSessionStorage = (key) => {
    const storage = window.sessionStorage;
    return storage.getItem(key);
};
export const removeValueFromSessionStorage = (key) => {
    const storage = window.sessionStorage;
    return storage.removeItem(key);
};
export const setValueInSessionStorage = (key, value) => {
    const storage = window.sessionStorage;
    storage.setItem(key, value);
};
//# sourceMappingURL=SessionStorageService.js.map